/* __next_internal_client_entry_do_not_use__ TextBadgesClientWrapper auto */ import { jsx as _jsx } from "react/jsx-runtime";
import { useProductTileClickProps } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductTileClickProvider/ProductTileClickContext";
import { Link } from "@faire/web--source/ui/LinkAnchor";
import React from "react";
export var TextBadgesClientWrapper = function(param) {
    var data = param.data, children = param.children;
    var _useProductTileClickProps = useProductTileClickProps(), onProductClick = _useProductTileClickProps.onProductClick, productLinkProps = _useProductTileClickProps.productLinkProps;
    var _productLinkProps_productUrl;
    return /*#__PURE__*/ _jsx(Link, {
        onClick: onProductClick,
        "data-test-id": data.dataTestId,
        to: (_productLinkProps_productUrl = productLinkProps === null || productLinkProps === void 0 ? void 0 : productLinkProps.productUrl) !== null && _productLinkProps_productUrl !== void 0 ? _productLinkProps_productUrl : "",
        replace: productLinkProps === null || productLinkProps === void 0 ? void 0 : productLinkProps.replace,
        children: children
    });
};
